<template>
  <unordered-list id="intent-examples"
                  :is-loading="isLoading"
                  :list="sortedIntentExamples"
                  :list-classes="['pt-2']"
  />
</template>

<script>
import intentExamplesService from '@/services/amio/intent-examples.service'
import UnorderedList from '@/components/common/UnorderedList'
import isEmpty from 'ramda/src/isEmpty'
import sort from 'ramda/src/sort'
import toaster from '@/utils/toaster'

export default {
  name: 'IntentSuggestionExamplesList',
  components: { UnorderedList },
  props: {
    intentId: {
      type: String,
      required: true
    }
  },

  watch: {
    intentId: {
      immediate: true,
      handler: async function () {
        this.isLoading = true
        try {
          this.intentExamples = (await intentExamplesService.list(this.intentId))
            .map(intentExample => intentExample.example)
        } catch (e) {
          toaster.error(e)
        } finally {
          this.isLoading = false
          this.$emit('intent-examples-loaded', !isEmpty(this.intentExamples))
        }
      }
    }
  },

  data() {
    return {
      intentExamples: [],
      isLoading: false
    }
  },

  computed: {
    sortedIntentExamples() {
      const stripped = this.intentExamples.map(example => this.stripHtmlTags(example))
      return sort((a, b) => a.localeCompare(b), stripped)
    }
  }
}
</script>
